import { ChangeDetectorRef, Injectable } from '@angular/core';
import { act, Actions, createEffect, ofType } from '@ngrx/effects';
import {
  map,
  catchError,
  tap,
  mergeMap,
  withLatestFrom,
  exhaustMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import * as fromAuthActions from '../actions/auth.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { NavigationExtras } from '@angular/router';
import { setLoadingSpinner } from '../actions/shared.action';

@Injectable()
export class AuthEffects {

  // login$ = createEffect(
  //   ()=> this.actions$.pipe(
  //     ofType(fromAuthActions.login),
  //     exhaustMap((action) => 
  //       this.authService.login(action).pipe(
  //         map((response)=>{
  //           console.log(response);
  //           this.store.dispatch(setLoadingSpinner({status : false}));
  //           return fromAuthActions.loginSuccess({data: response?.details})
  //         }),
  //         catchError((response)=>{
  //           this.store.dispatch(setLoadingSpinner({status : false}));
  //           // const error = {
  //           //   status : response.status,
  //           //   error : this.errorService.getErrorMessage
  //           // };
  //           return of(fromAuthActions.loginFailed({data : 'error'}))
  //         })
  //       )
  //     )
  //   )
  // )

  // loginSuccess$ = createEffect(
  //   ()=> this.actions$.pipe(
  //       ofType(fromAuthActions.loginSuccess),
  //       tap(async (action) =>{
  //         console.log("loginSuccess$",action.data);
  //         if(action.data){

  //         }
  //       })
  //     ),
  //   { dispatch: false }
  // )

  // loginFailed$ = createEffect(
  //   ()=> this.actions$.pipe(
  //       ofType(fromAuthActions.loginFailed),
  //       tap(async (action) =>{
  //         console.log("loginFailed$",action.data);
  //         if(action.data){
            
  //         }
  //       })
  //     ),
  //   { dispatch: false }
  // )

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
  ) {}
}
